<template>
  <van-overlay :show="isshow" :custom-style="custom" z-index="9999">
    <div class="wrapper">
      <div class="box">
        <van-loading size="24px" color="#1989fa" vertical
          >{{ text }}...</van-loading
        >
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default {
  data() {
    return {
      isshow: false,
      custom: { 'background-color': 'rgba(0, 0, 0, 0.3)' },
      text: '加载中'
    }
  },
  methods: {
    show(text) {
      this.text = text || '加载中'
      this.isshow = true
    },
    close() {
      this.isshow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15vh;
  height: 15vh;
  border-radius: 2vh;
  background-color: #fff;
}
</style>
